import React from 'react';
import { useMenuLogic } from './hooks/useMenuLogic';
import { formatDate, formatDateWithTime, pranzoCena } from './utils/menu2-utils';
import menuUtils from './utils/menu-utils';
import Menu2CategoryAccordion from './components/Menu2CategoryAccordion';
import Menu2OrderSummary from './components/Menu2OrderSummary';
import Menu2Modals from './components/Menu2Modals';
import OrderDateSelector from './components/Menu2OrderDateSelector';
import {  
  VStack,
} from '@chakra-ui/react';
function Cashier() {
  const logic = useMenuLogic();
  const [paymentType, setPaymentType] = React.useState(null);

  const isAdminCashierEnabled = !!logic.appSettings?.adminCashier;
  const isAdminCashier = logic.isAdmin && isAdminCashierEnabled;
  const isCashierView = logic.isCashier || isAdminCashier;
  const isAdminBlocked = logic.isAdmin && !isAdminCashierEnabled;

  // Calcolo stato di loading combinato come in Menu.js
  const isLoading = logic.isLoadingSettings || (logic.selectedDate && logic.isLoadingMenu);

  // console.log('logic', logic);
  return (
    <VStack spacing={4} align='stretch' mb={15} width='100%'>
      <OrderDateSelector
        selectedDate={logic.selectedDate}
        appSettings={logic.appSettings}
        isAdmin={logic.isAdmin}
        setShowModalSelectDate={logic.setShowModalSelectDate}
        setShowModalPriorityAccess={logic.setShowModalPriorityAccess}
        formatDate={formatDate}
        formatDateWithTime={formatDateWithTime}
        pranzoCena={pranzoCena}
      />
      <Menu2CategoryAccordion
        menu={logic.menu}
        increment={logic.increment}
        decrement={logic.decrement}
        product={logic.product}
        isCashier={isCashierView}
        appSettings={logic.appSettings}
      />
      <Menu2OrderSummary
        menu={logic.menu}
        menuUtils={menuUtils}
        voucher={logic.voucher}
        setVoucher={logic.setVoucher}
        isAdmin={isAdminBlocked}
        isCashier={isCashierView}
        isAdminCashier={isAdminCashier}
        isOperator={logic.isOperator}
        isPromoter={logic.isPromoter}
        isCustomer={logic.isCustomer}
        // appSettings={logic.appSettings}
        clearQuantities={menuUtils.clearQuantities}
        setMenu={logic.setMenu}
        rerender={logic.rerender}
        render={logic.render}
        setShowModalConfirmOrderCustomer={logic.setShowModalConfirmOrderCustomer}
        setShowModalConfirmOrderCashier={logic.setShowModalConfirmOrderCashier}
        // paymentType={paymentType}
        setPaymentType={setPaymentType}
      />
      <Menu2Modals
        isLoading={isLoading}
        progress={logic.progress}
        
        showModalPriorityAccess={logic.showModalPriorityAccess}
        setShowModalPriorityAccess={logic.setShowModalPriorityAccess}
        showModalSelectDate={logic.showModalSelectDate}
        setShowModalSelectDate={logic.setShowModalSelectDate}
        showModalAppIsClosed={logic.showModalAppIsClosed}
        setShowModalAppIsClosed={logic.setShowModalAppIsClosed}
        showModalBuyCustomer={logic.showModalBuyCustomer}
        setShowModalBuyCustomer={logic.setShowModalBuyCustomer}
        showModalConfirmOrderCustomer={logic.showModalConfirmOrderCustomer}
        setShowModalConfirmOrderCustomer={logic.setShowModalConfirmOrderCustomer}
        showModalConfirmOrderCashier={logic.showModalConfirmOrderCashier}
        setShowModalConfirmOrderCashier={logic.setShowModalConfirmOrderCashier}
        showModalResultCashier={logic.showModalResultCashier}
        setShowModalResultCashier={logic.setShowModalResultCashier}
       
        appSettings={logic.appSettings}
        selectedDate={logic.selectedDate}
        setSelectedDate={logic.setSelectedDate}
        
        reset={logic.reset}
        navigate={logic.navigate}
        
        checkoutUrl={logic.checkoutUrl}
        modalCashierText={logic.modalCashierText}
        setModalCashierText={logic.setModalCashierText}
        cashierOrderId={logic.cashierOrderId}
        setCashierOrderId={logic.setCashierOrderId}
        menu={logic.menu}
        handleCustomerOrderConfirm={logic.handleCustomerOrderConfirm}
        handleCashierOrderConfirm={logic.handleCashierOrderConfirm}
        paymentType={paymentType}

        formatDate={formatDate}
        formatDateWithTime={formatDateWithTime}
        pranzoCena={pranzoCena}
      />
    </VStack>
  );
}

export default Cashier; 